export default {
  data() {
    return {
      rules: {},
      form: this.initForm()
    }
  },
  methods: {
    initForm() {
      return {}
    }
  }
}

export const requireValidator = (message = 'Can not be empty') => {
  return {
    required: true,
    message,
    trigger: 'blur',
    validator: (rule, value, callback) => {
      if (typeof value === 'number' || typeof value === 'boolean') {
        if (!isEmpty(value)) {
          callback()
        } else {
          callback(rule.message())
        }
      } else {
        if (!value || isEmptyObj(value)) {
          callback(rule.message)
        } else {
          callback()
        }
      }
    }
  }
}

/**
 * @param message
 * @param {function(rule,value,callback):void} validator
 */
export const customizeValidator = (message, validator) => {
  return {
    message,
    trigger: 'blur',
    validator
  }
}

export const emailValidator = (message = 'Email address is invalid') => {
  return {
    message,
    trigger: 'blur',
    validator: (rule, value, callback) => {
      const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!value) {
        callback()
      }
      if (!reg.test(value)) {
        callback(rule.message)
      } else {
        callback()
      }
    }
  }
}

const isEmpty = value => {
  return value === null || value === undefined
}

const isEmptyObj = (obj) => {
  if (Number.isInteger(obj) && obj !== 0) {
    return false
  }
  return !obj || Object.keys(obj).length === 0
}

export class ValidationError extends Error {
  constructor(message) {
    super(message) // (1)
    this.name = 'ValidationError' // (2)
  }
}

